import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import styles from './styles/value-card.module.css';

export default function ValueCard({ value, description, valueMap, isFirst }) {
    const ref = useRef(null);
    
    const isFirstInView = useInView(ref, {
        once: true,
        amount: 0.7,
    });

    const isSecondInView = useInView(ref, {
        once: true,
        amount: 0.1,
    });

    const isInView = isFirst ? isFirstInView : isSecondInView;

    const cardMotion = {
        initial: { 
            opacity: 0, 
            y: 0 
        },
        animate: { 
            opacity: 1, 
            y: 0, 
            transition: { ease: 'easeOut', duration: 0.2, delay: isFirst ? 0.5 : 1.2 }
        }
    };

    const textMotion = {
        initial: { 
            opacity: 0, 
            y: isFirst ? -50 : 50 
        },
        animate: { 
            opacity: 1, 
            y: 0, 
            transition: { ease: 'easeOut', duration: 0.5, delay: isFirst ? 0.9 : 1.4 }
        }
    };

    return (
        <motion.div
            className={styles.wrapper}
            ref={ref}
            initial='initial'
            animate={isInView ? 'animate' : 'initial'}
            variants={cardMotion}
        >
            <div className={styles.containerValue}>
                <p>{value}</p>
                <motion.p
                    initial='initial'
                    animate={isInView ? 'animate' : 'initial'}
                    variants={textMotion}
                >
                    {description}
                </motion.p>
            </div>
            {valueMap.map(({ id, title, content }) => (
                <div className={styles.containerExample} key={id}>
                    <p className={styles.title}>{title}</p>
                    <motion.p
                        className={styles.content}
                        initial='initial'
                        animate={isInView ? 'animate' : 'initial'}
                        variants={textMotion}
                    >
                        {content}
                    </motion.p>
                </div>
            ))}
        </motion.div>
    );
}
